import React, { useEffect, useState } from "react";
import style from "./Priview.module.css";
import { badges, dummyImages } from "../../../constant/contants";
import BackIcon from "../../../Assets/BackIcon.svg";
import studentProfile from "../../../Assets/studentProfile.svg";
import location from "../../../Assets/location.svg";
import image3 from "../../../Assets/image3.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { deleteWork, getSingleStudentWork, getUserById } from "services/api";
import { CheckMediaType, StringToHTML } from "helper/helper";
import { AddEmbededVideo } from "helper/helper";
import { useSelector } from "react-redux";
import { Preview_mobile } from "./Preview_mobile";
import { useWindow } from "hooks/useWindow";
import { Box, Textarea, border } from "@chakra-ui/react";
import Swal from "sweetalert2";
import edit3 from "../../../Assets/edit3.svg";
import delete1 from "../../../Assets/delete1.svg";
import trash from "../../../Assets/trash.svg";

const Priview = () => {
  const { id, studentId } = useParams();
  const [studentData, setStudentData] = useState({});
  const [user, setUser] = useState({});
  const windowSize = useWindow();
  const student = useSelector((state) => state.student);
  const [readmore, setReadmore] = useState(false);
  const [studentUploadedWork, setStudentUploadedWork] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const tools = [
    "Unreal",
    "Unity",
    "Adobe Lightroom",
    "Unreal",
    "Unity",
    "Adobe Lightroom",
  ];

  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        const { data } = await getSingleStudentWork(id, studentId);

        // console.log(data)
        setStudentData(data?.data[0]);
        setUser(data?.userDetails);
      };
      fetchUser();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        const { data } = await getUserById(id);
        setUser(data?.data);
      };
      fetchUser();
    }
  }, [id]);

  const navigate = useNavigate();
  const deleteUploadWork = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      console.log("resu", result);
      if (result.isConfirmed) {
        try {
          const res = await deleteWork(id);
          const filterData = studentUploadedWork?.filter(
            (item) => item._id !== id
          );
          setStudentUploadedWork(filterData);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          navigate(-1, { replace: true });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <div className={style.main}>
      <div className={style.conatiner}>
        <div className={style.left}>
          <div className={style.nametext}>{studentData?.title}</div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              marginLeft: "-28px",
            }}
          >
            <div className={style.badgeswithIcon1}>
              <div className={style.text}>
                &nbsp;
                {/* {studentData?.tags?.split(',').map((i) => (
                  <div className={style.badgeswithIcon}>{i}</div>
                ))} */}
                {studentData?.projectType?.length > 0 ? (
                  <div className={style.ToolsIcon}>
                    {studentData?.projectType?.split(",").map((i) => (
                      <div className={style.badgeswithIcon}>{i}</div>
                    ))}
                  </div>
                ) : (
                  <>-</>
                )}
                {!id && (
                  <>
                    {studentData?.projectType?.split(",").map((i) => (
                      <div className={style.badgeswithIcon}>{i}</div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={style.AboutCont}>
            <p>About Project</p>
            {studentData?.about?.length > 0 ? (
              <Box
                className={style.aboutTxt}
                dangerouslySetInnerHTML={{
                  __html: StringToHTML(studentData?.about),
                }}
              ></Box>
            ) : (
              <></>
            )}
          </div>

          <div className={style.ToolsCont}>
            <p>Tools used</p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginLeft: "-24px",
              }}
            >
              {studentData?.tools?.length > 0 ? (
                <div className={style.ToolsIcon}>
                  {studentData?.tools?.split(",").map((i) => (
                    <div className={style.text1}>{i}</div>
                  ))}
                </div>
              ) : (
                <>-</>
              )}
            </div>
          </div>
          <div className={style.ToolsCont}>
            <p>Tags</p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginTop: "12px",
                marginLeft: "-24px",
              }}
            >
              {studentData?.tags?.length > 0 ? (
                <div className={style.ToolsIcon}>
                  {/* <div className={style.text1}>&nbsp;{studentData?.tags}</div> */}
                  {studentData?.tags?.split(",").map((i) => (
                    <div className={style.text1}>{i}</div>
                  ))}
                </div>
              ) : (
                <>-</>
              )}
            </div>
          </div>
        </div>

        <div className={style.right}>
          {/* back */}
          <div
            className={style.Back}
            onClick={() => navigate(-1, { replace: true })}
          >
            <img src={BackIcon} alt="BackIcon" />
            Back
          </div>
          {/* profile */}
          <div className={style.ProfileCont}>
            <div className={style.Profile}>
              <img
                src={user?.profilePhoto || student?.profilePhoto}
                alt="studentProfile"
                onError={(e) => (e.target.src = studentProfile)}
              />
            </div>
            <div className={style.detailsContainer}>
              <div className={style.student_name}>
                {user?.name || student?.name}
              </div>
              <div className={style.levelLocation}>
                <div className={style.level}>
                  {user?.jobTitle || student?.jobTitle}
                </div>
                <div className={style.line}></div>
                {student?.location?.length > 0 || user?.location ? (
                  <>
                    <img src={location} alt="location" />
                    <div className={style.location}>
                      &nbsp;{user?.location || student?.location}
                    </div>
                  </>
                ) : (
                  <>-</>
                )}
              </div>
            </div>
            {/* edit and delete button */}
            {!studentId && (
              <div className={style.editdeleteBtn}>
                {/* <button
                onClick={() => navigate(`/hiring/student/editwork/${id}`)}
              >
                Edit
              </button> */}

                <img
                  src={edit3}
                  alt="edit"
                  style={{
                    height: "42px",
                    padding: "8px",
                    border: "1px solid #E7E6E8",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/hiring/student/editwork/${id}`)}
                />
                <button
                  onClick={(_id) => deleteUploadWork(_id)}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className={style.image_container}>
                    <div className={style.imgContainer}>
                      <div className={style.normal_image}>
                        {isHovered ? (
                          <img src={trash} alt="dele" />
                        ) : (
                          <img src={delete1} alt="dele" />
                        )}
                      </div>
                    </div>
                  </div>
                  Delete Project
                </button>
              </div>
            )}
          </div>
          {/* priveiw images */}
          {studentData?.url?.map((v) => (
            <>
              <div className={style.Priview_images}>
                {CheckMediaType(v) === "image" && <img src={v} alt="" />}
                {CheckMediaType(v) === "video" && (
                  <video src={v} alt="" controls />
                )}
              </div>

              {CheckMediaType(v) === "other" && (
                <iframe
                  src={AddEmbededVideo(v)}
                  alt=""
                  height={"520px"}
                  width={"100%"}
                  style={{
                    borderRadius: "15px",
                    aspectRatio: "1:1",
                  }}
                />
              )}
            </>
          ))}
        </div>
      </div>
      {windowSize < 500 && (
        <div className={style.mobile}>
          <Preview_mobile />
        </div>
      )}
    </div>
  );
};

export default Priview;
